import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false,
})
export class AlertComponent {
  @Input() visible: boolean = false;
  @Input() width: string = '450px';
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() icon: string = 'icon icon-warning';
  @ViewChild('dialog') dialog: any;


  onHide() {
    this.visible = false;
    this.visibleChange.emit(false);
  }
  onShow() {
    this.visible = true;
    this.visibleChange.emit(true);
  }
}
